import { lazy } from 'react'
import { defineGrowthEvent } from '~/features/GrowthEvent/common/framework'

export default defineGrowthEvent({
  id: 'springPromotionEvent2026',
  eventRoute: 'spring-promotion-2026',
  EventPage: lazy(() => import('./EventPage')),
  SlotContents: lazy(() => import('./SlotContents')),
})
